import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DateUtilService } from 'gung-common';
import { AuthService, BackendInterceptor, LocationConfigService, MetadataService, OpenOrderTableComponent } from 'gung-standard';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'cult-cult-open-orders-table',
  templateUrl: './cult-open-orders-table.component.html',
  styleUrls: ['./cult-open-orders-table.component.scss']
})
export class CultOpenOrdersTableComponent extends JeevesOpenOrderTableListComponent {
  constructor(
    protected locationConfigService: LocationConfigService,
    protected router: Router,
    public dateUtilService: DateUtilService,
    protected metadataService: MetadataService,
    protected authService: AuthService,
    protected backendInterceptor: BackendInterceptor
  ) {
    super(locationConfigService, router, dateUtilService, authService, backendInterceptor);
  }

  getSalespersonMetadata(key: string): string {
    return this.metadataService.getMetadataValue('salj', 'saljarenamn', key) || '-';
  }
}
